import { render, staticRenderFns } from "./Pika.vue?vue&type=template&id=d1aa348e&scoped=true"
import script from "./Pika.vue?vue&type=script&lang=js"
export * from "./Pika.vue?vue&type=script&lang=js"
import style0 from "./Pika.vue?vue&type=style&index=0&id=d1aa348e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1aa348e",
  null
  
)

export default component.exports